import * as React from "react";
import { memo } from "react";
const SvgAccountButtonBg = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 316, height: 72, viewBox: "0 0 316 72", fill: "none", ...props }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", { d: "M6 14.8941L11.6946 7.66644L302.417 6L306 50.6644L296.145 62L11.6946 58.8028L6 14.8941Z", fill: "currentColor" })));
const Memo = memo(SvgAccountButtonBg);
export default Memo;
